import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

//工单列表查询
export function getDingCheck(data) {
    return request({
        url: serviceName + `/ding/check/page`,
        method: 'post',
        data: data
    })
}

// 更新列表
export function updateDing(data) {
    return request({
        url: serviceName + `/dingding/pull_check_report`,
        method: 'get',
        data: data
    })
}
